// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Wp","buttonPrev":"e_Xp","buttonNext":"e_Yp","hidden":"e_Zp","iconPrev":"e__p","iconNext":"e_0p","scrollView":"e_1p","card":"e_2p","scroller":"e_3p"};